import { FC } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import intl from 'components/i18n/ReactIntlWrapper';


type StatusSelectProps = {
  handleStatusChange: (event: any, value: any) => void,
  selectedStatus: any,
  status: any,
  disabled: boolean,
  defaultValue: any,
  isClearable: boolean
};

const StatusSelect: FC<StatusSelectProps> = ({ handleStatusChange, status, selectedStatus, disabled, defaultValue, isClearable }) => {
  let statusOptions = [];
  if (status && typeof status === 'object') {
    const numericKeys = Object.keys(status).filter(key => !isNaN(Number(key)));
    statusOptions = numericKeys.map(key => {
      const value = status[key];
      const isActive = value === 'ACTIVE';
      return {
        id: Number(key),
        value: value,
        active: isActive,
        status: isActive ? intl.get(`statusSelect.active`) : intl.get(`statusSelect.inactive`)
      };
    });
  }
  let defaultOption = defaultValue ? statusOptions[0] : null;

  return (
    <Autocomplete
      id="status"
      options={statusOptions || []}
      getOptionLabel={(option) => option.status || ''}
      value={statusOptions?.find((option) => 
        option.id === selectedStatus || 
        option.value === selectedStatus || 
        option.active === selectedStatus
      ) || defaultOption}
      onChange={(event, value) => handleStatusChange(event, value)}
      isOptionEqualToValue={(option, value) => 
        option && value && (
          option.id === value.id || 
          option.value === value.value
        )
      }
      disabled={disabled}
      clearIcon={isClearable ? undefined : null}
      renderInput={(params) => (
        <TextField
          {...params}
          label={intl.get('statusSelect.placeholder')}
          variant="outlined"
          fullWidth
        />
      )}
      clearOnEscape={isClearable}
    />
  );
}

export default StatusSelect;
